import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const PageHeader = ({ backTo = "/#pack-gospel" }) => (
  <header className="fixed top-0 z-50 w-full border-b border-[#163D43] bg-[#041214]/80 backdrop-blur-md" data-testid="page-header">
    <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 md:px-10">
      <Link to="/" data-testid="page-header-logo"><Logo /></Link>
      <Link to={backTo} data-testid="page-header-back" className="inline-flex items-center gap-2 text-sm text-teal-100 hover:text-[#2DD4BF]">
        <ArrowLeft className="h-4 w-4" /> Voltar ao site
      </Link>
    </div>
  </header>
);
